import { Component, OnInit } from '@angular/core';
import { UploadComponent } from 'src/app/modules/setting/upload/upload.component';
import { MatDialog } from '@angular/material/dialog';
import { SettingModel } from '../../core/models/classes/setting';
import { SettingsService } from '../../core/services/settings.service';
import { EmailsettingsComponent } from './emailsettings/emailsettings.component';
import { LanguageComponent } from './language/language.component';
import { MapsettingsComponent } from './mapsettings/mapsettings.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
})
export class SettingComponent implements OnInit {
  fileUrl;
  title:string='';
  wmsLink: string = '';
  mapCacheId: string = 'd79c26749188426381c70996c0bd18ca';
  mapCacheName: string = '';
  srid: number = 0;
  server: string = '';
  port: string = '';
  email: string = '';
  pass: string = '';
  ssl: boolean = false;
  attributation: string = 'OpenStreetMap® contributors';
  domainname:string='';
  appSettings: SettingModel[] = [];
 
  constructor(
    private settingService: SettingsService,
    private sanitizer: DomSanitizer,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.title = $localize `General`;
    this.settingService.getSettings().subscribe({
      next: (s) => {
          this.mapCacheId = s.mapCacheId;
          this.wmsLink = s.wmsLink;
          this.mapCacheName = s.mapCacheName;
          this.srid = s.srid;
          this.server = s.server;
          this.port = s.port;
          this.email = s.email;
          this.pass = s.password;
          this.ssl = s.ssl;
          this.domainname = s.domainName;
          this.attributation = s.mapAttributation;
      },
      error: (err) => {

        throw Error(err.Status);
      },
    });

    this.settingService.exportSettings().subscribe({
      next: (data: any) => {
        var setting = JSON.stringify(data);
        const blob = new Blob([setting], { type: 'application/json' });
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          window.URL.createObjectURL(blob)
        );
      },
    });
  }

  onSave(): void {
    var setting = new SettingModel();
    setting.mapCacheId = this.mapCacheId;
    setting.mapCacheName = this.mapCacheName;
    setting.srid = this.srid;
    setting.wmsLink = this.wmsLink;
    setting.server = this.server;
    setting.email = this.email;
    setting.password = this.pass;
    setting.port = this.port;
    setting.ssl = this.ssl;
    setting.domainName=this.domainname;

    this.settingService.addSettings(setting).subscribe({
      next: (data) => {
        if (data.status === 200) {
        }
      },
    });
  }

  onImport() {
    this.dialog.open(UploadComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }

  onExport() {
    this._snackBar.open($localize `Settings exported successfully`, '', {
      duration: 3000
    });
  }

  setEmailSettings(){
    this.dialog.open(EmailsettingsComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }

  setMapSettings(){
    this.dialog.open(MapsettingsComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }

  setLanguageSettings(){
    this.dialog.open(LanguageComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }
}
